module.exports = __webpack_public_path__ + "img/not_mobile_supported.34e368da.svg";